import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { FormTextField } from 'ui';

export interface AvatarCardLinkWidgetFields extends BaseWidgetFormFields {
  imageUrl: string;
  imageAlt: string;
  title: string;
  subtitle: string;
  linkHref: string;
  linkText: string;
}

export const AvatarCardLinkWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <>
      <FormTextField id="imageUrl" name="imageUrl" label="Image URL" fullWidth />
      <FormTextField id="imageAlt" name="imageAlt" label="Image alt text" fullWidth />
      <FormTextField id="title" name="title" label="Title" fullWidth />
      <FormTextField id="subtitle" name="subtitle" label="Subtitle" fullWidth />
      <FormTextField id="linkText" name="linkText" label="Link text" fullWidth />
      <FormTextField id="linkHref" name="linkHref" label="Link href" fullWidth />
    </>
  );
};
